import { AccountsContext } from 'context/accounts/AccountsContext';
import { FormApi } from 'final-form';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import { Redirect } from 'react-router';
import { Loader, LocaleContext, NotificationsContext, NotificationTypes } from 'shared';
import { useQuery } from 'shared/hooks';
import { UpdateAccountPayload } from 'store/api/types';

import { getErrorMessage } from '../../../utils/getErrorMessage/getErrorMessage';
import { PageWrapper } from '../Dashboard.styles';

import { AccountProps } from './Account.types';
import { AccountDetails } from './accountDetails/AccountDetails';

export const Account = ({ onFetchAccount, onUpdateAccount, history, match }: AccountProps) => {
  const [openedModal, setOpenedModal] = useState<null | string>(null);
  const localeContext = useContext(LocaleContext);
  const notificationsContext = useContext(NotificationsContext);
  const accountsContext = useContext(AccountsContext);
  const { loading, response, error, handleFetch } = useQuery(onFetchAccount);
  const account = response ? response.payload : undefined;

  useEffect(() => {
    if (account && accountsContext.activeAccount && accountsContext.activeAccount.name !== account.name) {
      accountsContext.updateAccount({ ...accountsContext.activeAccount, name: account.name });
    }
  }, [account, accountsContext]);

  const handleSetOpenedModal = (type: string | null) => () => {
    setOpenedModal(type);
  };

  const handleEditAccount = async (values: UpdateAccountPayload, form: FormApi) => {
    try {
      return await onUpdateAccount(values, form, () => {
        form.reset();
        handleSetOpenedModal(null)();
        handleFetch(true);

        notificationsContext.showNotification({
          message: localeContext.formatMessage({ id: 'ACCOUNT.EDIT-SUCCESS' }),
          time: 1000,
          type: NotificationTypes.SUCCESS,
        });
      });
    } catch (error) {
      notificationsContext.showNotification({
        message: getErrorMessage(error, localeContext),
        time: 1000,
        type: NotificationTypes.ERROR,
      });
    }
  };

  return (
    <Fragment>
      {error && <Redirect to="/" />}

      {loading && !response && <Loader />}

      {response && (
        <PageWrapper className="account">
          <AccountDetails
            account={response.payload}
            openedModal={openedModal}
            onSetOpenedModal={handleSetOpenedModal}
            onSubmit={handleEditAccount}
          />
        </PageWrapper>
      )}
    </Fragment>
  );
};
